import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Dialog from '..'
import ButtonRounded from '../../ButtonRounded'
import { TickIcon, CrossIcon, ChevronIcon } from '../../icons'
import styles from './styles'

class PostcodeDialog extends Component {
  state = {
    postcode: '',
    postcodeIsValid: null,
  }

  handleInputChange = (event) => {
    const { value: postcode } = event.target
    const postcodeIsValid = /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {0,1}[0-9][ABD-HJLN-UW-Z]{2}|GIR ?0AA)$/i.test(postcode)

    this.setState({
      postcode,
      postcodeIsValid,
    })
  }

  handleBackClick = () => window.history.back()

  handleInputSubmit = (e) => {
    e.preventDefault()
    if (this.state.postcodeIsValid) {
      this.props.onPostcodeSubmit(this.state.postcode)
    }
  }

  render() {
    const validationClassName = this.state.postcodeIsValid ? 'is-valid' : 'is-invalid'
    const inputHasText = Boolean(this.state.postcode.length)

    return (
      <div className="PostcodeDialog">
        <Dialog
          title="A quick check"
          subtitle="Due to licensing regulations we can only show this content to viewers in Scotland."
          supplementaryText="To watch this video on STV Player we need to know your location. To find out if it is available to you, type your postcode below — don't worry though, we will not store this information."
        />
        <form className="postcode-entry" onSubmit={this.handleInputSubmit}>
          <div className="input-validation-group">
            <div className="input-container">
              <input
                className={`input ${inputHasText ? validationClassName : ''}`}
                type="text"
                value={this.state.postcode}
                onChange={this.handleInputChange}
                autoComplete="postal-code"
              />
              <div className="icon-container">
                { inputHasText && this.state.postcodeIsValid && <TickIcon color="#68b000" /> }
                { inputHasText && !this.state.postcodeIsValid && <CrossIcon color="#f33" /> }
              </div>
            </div>
            { inputHasText && (
              <span className={`validation-text ${validationClassName}`}>
                { this.state.postcodeIsValid ? 'Postcode is valid' : 'Please enter a valid UK postcode' }
              </span>
            )}
          </div>

          <div className="button-group">
            <ButtonRounded
              theme="dark"
              text="Back"
              uppercase
              onClick={this.handleBackClick}
            />
            <ButtonRounded
              type="submit"
              text="OK"
              icon={<ChevronIcon color="#fff" />}
              inactive={!this.state.postcodeIsValid}
            />
          </div>
        </form>
        <style jsx>{styles}</style>
      </div>
    )
  }
}

PostcodeDialog.propTypes = {
  onPostcodeSubmit: PropTypes.func,
}

PostcodeDialog.defaultProps = {
  onPostcodeSubmit: () => {},
}

export default PostcodeDialog
